import { Button, Modal } from "antd";
import ListPermissionAddToMenu from "./ListPermissionAddToMenu";

const ModalAddPermissionInMenu = (props) => {
  const {
    isOpen,
    onCancel,
    handleRemovePermission,
    handleSelectPermission,
    existedListingPermission,
  } = props;

  return (
    <>
      <Modal
        title="Thêm quyền cho menu"
        closable={{ "aria-label": "Custom Close Button" }}
        open={isOpen}
        onOk={() => {}}
        onCancel={onCancel}
        width={"70%"}
        footer={<Button onClick={onCancel}>Đóng</Button>}
      >
        <ListPermissionAddToMenu
          onRemovePermission={(Ids) => handleRemovePermission(Ids[0])}
          onSelectPermission={(permission) =>
            handleSelectPermission(permission)
          }
          existedListPermission={existedListingPermission}
        />
      </Modal>
    </>
  );
};
export default ModalAddPermissionInMenu;
